import { render, staticRenderFns } from "./UserSiteDetailsTab.vue?vue&type=template&id=22126f96"
import script from "./UserSiteDetailsTab.vue?vue&type=script&lang=js"
export * from "./UserSiteDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports